import { useEffect, useRef, useState } from "react";
import assetActions from "../../assets/actions";
import { useDispatch, useSelector } from "react-redux";
import { dropdownKeys, parentFields, surveyTypes } from "../constants";
import _, { isEqual } from "lodash";
import actions from "../actions";
import mobileRecomActions from "../../mobileRecommendation/actions";
import { useHistory, useParams, useLocation } from "react-router-dom";
import qs from "query-string";
import {
    denormalizeToFlat,
    findInfoPathFromBreadCrump,
    findPrevPathFromBreadCrumpData,
    getCurrentAge,
    getUsefullLifeRemaining,
    popBreadCrumpOnPageClose,
    showAlert as showAlertUtil
} from "../../../config/utils";
import assetSettingsActions from "../../assetSettings/actions";
import normalRecomStatusActions from "../../Status/action";
import projectActions from "../../project/actions";
import normalRecomActions from "../../recommendations/actions";
import { DEFALUT_BAND_VALUE } from "../../mobileRecommendation/constants";
import commonActions from "../../common/actions";
import { getVisibilityConditionFields, shouldShowField } from "./visibilityConditionUtils";
import {
    CAPACITY_UNIT_FIELD,
    CRITICALITY_FIELD,
    CURRENT_AGE_FIELD,
    END_OF_SERVICE_LIFE_FIELD,
    INSTALLED_YEAR_FIELD,
    SERVICE_LIFE_FIELD,
    USEFUL_LIFE_REMAINING_FIELD,
    getEndOfServiceLife,
    getUniformatAutoValues,
    getUniformatChangeSummary,
    getUniformatLevel,
    getUniformatValuesWithDerivedFields,
    getRecommendationLifecycleFieldKeys,
    getSubsystemServiceLifeChangeSummary
} from "../utils";

const useSurveyAssetFrom = ({ initialState, surveyProject, getInitialSurveyAsset, isMobileRecommendation, projectId }) => {
    const { id } = useParams();
    const queryParam = qs.parse(useLocation()?.search);

    const [initialData, setInitialData] = useState({});
    const [fieldSearch, setFieldSearch] = useState("");
    const [data, setData] = useState({});
    const [staticData, setStaticData] = useState({});
    const [errorParams, setErrorParams] = useState({});
    const [showErrorBorder, setShowErrorBorder] = useState(false);
    const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false);
    const [invalidFields, setInvalidFields] = useState(null);
    const [alertMessage, setAlertMessage] = useState("");
    const [showCreateDynamicForm, setShowCreateDynamicForm] = useState({ show: false, value: "", entity: "" });
    const [pendingServiceLifeChange, setPendingServiceLifeChange] = useState(null);
    const { getStaticDropdownValues } = useSelector(state => state?.assetSettingsReducer);
    const updateDataRef = useRef(null);
    const history = useHistory();
    const { getSurveyAssetById, updateSurveyAssetFieldsResponse, uniformatList, getSuggestionDropdown } = useSelector(
        state => state.assetSurveyProjectReducer
    );
    const { getMobileRecommendationByIdResponse, updateMobileRecommendationFieldsResponse, getMobileRecommendationDropdownResponse } = useSelector(
        state => state.mobileRecommendationsReducer
    );
    const { dropDownList } = useSelector(state => state.assetReducer);
    const { priorityElementsDropDownResponse, getRecommendationTemplatesResponse } = useSelector(state => state.recommendationsReducer);
    const { getProjectByIdResponse } = useSelector(state => state?.projectReducer);
    const { getStatusDropdwnResponse } = useSelector(state => state?.recommendationStatusReducer);

    const dispatch = useDispatch();
    const prevInitialStateRef = useRef();

    useEffect(() => {
        return () => {
            if (!isMobileRecommendation) dispatch(actions.resetForm());
            else dispatch(mobileRecomActions.resetForm());
        };
    }, []);

    useEffect(() => {
        if (getSurveyAssetById) {
            setStaticData({
                code: getSurveyAssetById?.data?.asset?.code ?? "-",
                asset_survey_project_name: getSurveyAssetById?.data?.asset?.asset_survey_project?.name ?? "-",
                asset_surveyor_name: getSurveyAssetById?.data?.asset?.asset_surveyor_id?.name ?? "-",
                guid: getSurveyAssetById?.data?.asset?.guid ?? "-",
                latitude: getSurveyAssetById?.data?.asset?.latitude ?? "-",
                longitude: getSurveyAssetById?.data?.asset?.longitude ?? "-",
                asset_surveyed_time: getSurveyAssetById?.data?.asset?.asset_surveyed_time ?? "-",
                modified_time: getSurveyAssetById?.data?.asset?.asset_surveyed_time ?? "-",
                created_at: getSurveyAssetById?.data?.asset?.created_at ?? "-",
                updated_at: getSurveyAssetById?.data?.asset?.updated_at ?? "-",
                survey_type: surveyTypes?.[getSurveyAssetById?.data?.asset?.survey_type] ?? "-",
                synced_time: getSurveyAssetById?.data?.asset?.synced_time ?? "-",
                resync: getSurveyAssetById?.data?.asset?.resync ?? "-",
                remote_id: getSurveyAssetById?.data?.asset?.remote_id ?? "-"
            });
        }
    }, [getSurveyAssetById]);

    useEffect(() => {
        if (!isMobileRecommendation) {
            setData(initialState);
            setInitialData(initialState);
        }
    }, [initialState]);

    useEffect(() => {
        if (Object.keys(initialData)?.length && !_.isEqual(data, initialData)) {
            dispatch(commonActions.setFormDirty(true));
        } else {
            dispatch(commonActions.setFormDirty(false));
        }
    }, [data, initialData]);

    useEffect(() => {
        if (!isEqual(prevInitialStateRef.current, initialState) && isMobileRecommendation && !isEqual(initialState, DEFALUT_BAND_VALUE)) {
            getInitialDropdowns();
            prevInitialStateRef.current = initialState;
            setData(initialState);
            setInitialData(initialState);
        }
        if (!isMobileRecommendation) {
            getInitialDropdowns();
        }
    }, [initialState]);

    const showAlert = () => showAlertUtil(alertMessage);

    useEffect(() => {
        if (alertMessage) {
            showAlert();
            setAlertMessage("");
        }
    }, [alertMessage]);

    useEffect(() => {
        if (updateDataRef?.current)
            if (updateSurveyAssetFieldsResponse && !isMobileRecommendation) {
                updateDataRef.current = false;
                const { success, message = "", detail = null, error } = updateSurveyAssetFieldsResponse;
                if (success) {
                    setAlertMessage("Survey asset updated successfully");
                    getInitialSurveyAsset();
                    setTimeout(() => {
                        cancelForm();
                    }, 1000);
                } else {
                    setAlertMessage(typeof detail === "string" ? detail : message ? message : error);
                }
            } else if (updateMobileRecommendationFieldsResponse) {
                updateDataRef.current = false;
                const { success, message = "", detail = null, error } = updateMobileRecommendationFieldsResponse;
                if (success) {
                    setAlertMessage("Mobile Recommendation updated successfully");
                    setTimeout(() => {
                        cancelForm();
                    }, 1000);
                } else {
                    setAlertMessage(typeof detail === "string" ? detail : message ? message : error);
                }
            }
    }, [updateSurveyAssetFieldsResponse, updateMobileRecommendationFieldsResponse]);

    const hasInvalidFields = () => {
        let invalidFields = null;
        let isInvalid = false;
        const allFields = getVisibilityConditionFields(data);
        Object.values(data).forEach(e => {
            Object.entries(e).forEach(([eachFieldKey, eachFieldValue]) => {
                const recommendationType = data?.Recommendations?.recommendation_type?.value?.toLowerCase();
                if (!shouldShowField(eachFieldValue, allFields)) return;
                if (
                    eachFieldValue?.group_field?.toLowerCase() === "additional details" &&
                    recommendationType === "asset" &&
                    isMobileRecommendation &&
                    eachFieldKey === "asset_condition_id"
                ) {
                    return;
                }

                if (
                    eachFieldValue?.group_field === "Asset" &&
                    (recommendationType !== "asset" || recommendationType === "") &&
                    isMobileRecommendation
                )
                    return;
                if (eachFieldValue?.invalid) {
                    isInvalid = true;
                    invalidFields = [...(invalidFields ?? []), { label: [eachFieldValue?.label], value: eachFieldValue?.value }];
                }
            });
        });

        setInvalidFields(invalidFields);

        return isInvalid;
    };

    const handleDataOnDynamicFormSubmit = (entity, responseId, responseName) => {
        const clientId = !isMobileRecommendation ? surveyProject?.client_id : queryParam?.c_id;
        let asParamData = field => {
            const paramFields = {
                building_id: "site_id",
                system_id: "trade_id",
                sub_system_id: "system_id",
                "assets.building_id": "assets.site_id",
                "assets.floor_id": "assets.building_id",
                "assets.addition_id": "assets.building_id",
                "assets.system_id": "assets.trade_id",
                "assets.sub_system_id": "assets.system_id"
            };

            let params = null;
            if (paramFields?.[field])
                params = {
                    [isMobileRecommendation ? paramFields?.[field] : paramFields?.[field]?.split(".")?.[1]]: getValue(paramFields?.[field]),
                    ...(isMobileRecommendation && { project_id: projectId })
                };
            else if (field === "asset_condition_id") {
                const fields = Object.values(initialState).reduce((acc, item) => {
                    acc = [...acc, ...Object.values(item)];
                    return acc;
                }, []);
                let isAssetType = (fields ?? [])?.find(e => e?.field_name === "recommendation_type" && e?.value === "asset");
                if (isAssetType && clientId) params = { asset_condition_id: { client_id: clientId } };
            }
            if (!isMobileRecommendation) params = { ...params, client_id: clientId };

            return params;
        };

        const dropdownFields = {
            floor: "building_id",
            "assets.floor_id": "assets.building_id",
            addition_id: "building_id",
            "assets.addition_id": "assets.building_id",
            site_id: "region_id",
            "assets.site_id": "assets.region_id"
        };

        const params =
            entity === "main_building_type_id"
                ? { client_id: clientId }
                : entity === "assets.manufacturer"
                ? {
                      current_manufacturer: responseId
                  }
                : asParamData(entity);

        const idToBePassed = params ? params : dropdownFields?.[entity] ? getValue(dropdownFields?.[entity]) : projectId;

        const assetDropdownEntity = {
            "assets.asset_type_id": "asset_types",
            "assets.main_category_id": "main_categories",
            "assets.manufacturer": "manufacturers",
            "assets.client_asset_condition_id": "asset_conditions",
            "assets.asset_status_id": "asset_statuses",
            "assets.region_id": "regions",
            "assets.site_id": "sites",
            "assets.building_id": "buildings",
            "assets.floor_id": "floors",
            "assets.addition_id": "additions",
            "assets.trade_id": "trades",
            "assets.system_id": "systems",
            "assets.sub_system_id": "sub_systems",
            "buildings.main_building_type_id": "building_types"
        };
        const isMobileDropdownFields = ["regions", "sites", "buildings", "floors", "additions"];

        const service = [
            isMobileRecommendation ? entity : assetDropdownEntity?.[entity],
            !isMobileRecommendation
                ? { ...params, field: assetDropdownEntity?.[entity] }
                : entity === "initiative_id"
                ? { project_id: projectId }
                : entity === "region_id"
                ? clientId
                : idToBePassed,
            params,
            !isMobileRecommendation && isMobileDropdownFields?.includes(assetDropdownEntity?.[entity])
        ];
        dispatch(
            isMobileRecommendation
                ? entity === "assets.manufacturer_id" || entity === "manufacturer_id"
                    ? assetActions.getDropdownList("manufacturers", {
                          current_manufacturer: responseId,
                          client_id: clientId
                      })
                    : entity === "asset_conditions" || entity === "assets.client_asset_condition_id"
                    ? assetActions.getDropdownList("asset_conditions", { client_id: clientId })
                    : mobileRecomActions.getMobileRecommendationDropdowns(...service)
                : assetActions.getDropdownList(...service)
        );
        handleChange(
            { name: entity, value: responseId, responseName },
            ["assets.building_id", "building_id", "system_id", "sub_system_id"].includes(entity)
        );
    };

    const getValue = field =>
        Object.values(data ?? {}).reduce((acc, item) => {
            acc = { ...acc, ...item };
            return acc;
        }, {})?.[field]?.uuid;

    const isFieldInvalidOrEmpty = field => {
        const mergedValue = Object.values(data ?? {}).reduce((acc, item) => {
            acc = { ...acc, ...item };
            return acc;
        }, {})?.[field];
        const { value = "", uuid = "" } = mergedValue ?? {};
        return !(value && uuid);
    };

    const getLabel = field =>
        Object.values(data ?? {}).reduce((acc, item) => {
            acc = { ...acc, ...item };
            return acc;
        }, {})?.[field]?.label;

    const toggleCreateDynamicForm = (entity, value) => {
        if (parentFields?.[entity] && parentFields?.[entity].some(e => isFieldInvalidOrEmpty(e))) {
            const parentLabel = parentFields?.[entity]?.reduce((acc, item) => {
                acc = acc + (isFieldInvalidOrEmpty(item) ? `${acc ? "," : ""} ${getLabel(item)}` : "");
                return acc;
            }, "");
            setAlertMessage(`There seems to be no parent entity (${parentLabel}) selected. Kindly choose/create one.`);
        } else {
            const recommendationResponse = isMobileRecommendation
                ? getMobileRecommendationByIdResponse?.recommendation
                : getSurveyAssetById?.data?.asset;
            const autoFields = isMobileRecommendation
                ? {
                      consultancy_id: recommendationResponse?.project?.consultancy_id,
                      client_id: recommendationResponse?.project?.client_id,
                      building_id: getValue("building_id"),
                      project_ids: recommendationResponse?.project?.id,
                      region_id: getValue("region_id"),
                      trade_id: getValue("trade_id"),
                      system_id: getValue("system_id"),
                      site_id: getValue("site_id"),
                      main_building_type_id: getValue("main_building_type_id")
                  }
                : {
                      consultancy_id: recommendationResponse?.asset_survey_project?.consultancy_id,
                      client_id: recommendationResponse?.asset_survey_project?.client_id,
                      building_id: getValue("assets.building_id"),
                      region_id: getValue("assets.region_id"),
                      trade_id: getValue("assets.trade_id"),
                      system_id: getValue("assets.system_id"),
                      site_id: getValue("assets.site_id"),
                      main_building_type_id: getValue("buildings.main_building_type_id")
                  };

            const dropDownOptions = {
                consultancy: [
                    {
                        id: isMobileRecommendation
                            ? recommendationResponse?.project?.consultancy_id
                            : recommendationResponse?.asset_survey_project?.consultancy_id,
                        name: isMobileRecommendation
                            ? recommendationResponse?.project?.consultancy_name
                            : recommendationResponse?.asset_survey_project?.consultancy_name
                    }
                ],
                client: [
                    {
                        id: isMobileRecommendation
                            ? recommendationResponse?.project?.client_id
                            : recommendationResponse?.asset_survey_project?.client_id,
                        name: isMobileRecommendation
                            ? recommendationResponse?.project?.name
                            : recommendationResponse?.asset_survey_project?.client_name
                    }
                ],
                project: [
                    {
                        id: recommendationResponse?.project?.id,
                        name: recommendationResponse?.project?.name
                    }
                ]
            };
            setShowCreateDynamicForm(
                entity
                    ? {
                          show: true,
                          entity,
                          value,
                          autoFields,
                          dropDownOptions,
                          onFormSubmit: (basicDetails, id) => {
                              handleDataOnDynamicFormSubmit(entity, id, basicDetails?.name);
                          }
                      }
                    : { show: false, entity: "", value: "", autoFields: null }
            );
        }
    };

    const handleSubmit = () => {
        if (validateForm()) {
            if (!isMobileRecommendation) {
                const assetStaticFields = getSurveyAssetById?.data?.asset?.asset_static_fields ?? {};
                const assetDynamicFields = getSurveyAssetById?.data?.asset?.asset_dynamic_fields ?? {};
                let updatedStaticFields;
                let updatedDynamicFields;
                Object.entries(data).forEach(([key, fields]) => {
                    Object.entries(fields ?? {}).forEach(([eachFieldKey, eachFieldValue]) => {
                        const isStaticField = assetStaticFields?.[eachFieldKey];
                        if (
                            isStaticField &&
                            (!_.isEqual(isStaticField?.value, eachFieldValue?.value) || !_.isEqual(isStaticField?.uuid, eachFieldValue?.uuid))
                        ) {
                            updatedStaticFields = {
                                ...(updatedStaticFields ?? {}),
                                [eachFieldKey]: {
                                    value: eachFieldValue?.value,
                                    uuid: eachFieldValue?.uuid,
                                    invalid: eachFieldValue?.invalid,
                                    old_value: {
                                        value: isStaticField?.value,
                                        uuid: isStaticField?.uuid,
                                        invalid: isStaticField?.invalid,
                                        label: isStaticField?.label
                                    }
                                }
                            };
                        } else {
                            const isDynamicField = assetDynamicFields?.[eachFieldKey];
                            if (
                                isDynamicField &&
                                (!_.isEqual(isDynamicField?.value, eachFieldValue?.value) || !_.isEqual(isDynamicField?.uuid, eachFieldValue?.uuid))
                            ) {
                                updatedDynamicFields = {
                                    ...(updatedDynamicFields ?? {}),
                                    [eachFieldKey]: {
                                        value: eachFieldValue?.value,
                                        uuid: eachFieldValue?.uuid,
                                        invalid: eachFieldValue?.invalid,
                                        old_value: {
                                            value: isDynamicField?.value,
                                            uuid: isDynamicField?.uuid,
                                            invalid: isDynamicField?.invalid,
                                            label: isDynamicField?.label
                                        }
                                    }
                                };
                            }
                        }
                    });
                });
                const params = { asset_dynamic_fields: updatedDynamicFields, asset_static_fields: updatedStaticFields };
                updateDataRef.current = true;
                dispatch(actions.updateSurveyAssetFields(id, params));
            } else {
                const dynamicFields = getMobileRecommendationByIdResponse?.recommendation?.dynamic_fields;
                let updatedLogFields = {};
                let updatedDynamicFields = {};
                Object.entries(data).forEach(([key, fields]) => {
                    if (key === "Survey Details") return;
                    Object.entries(fields ?? {}).forEach(([eachFieldKey, eachFieldValue]) => {
                        if (eachFieldKey?.startsWith?.("survey_details.")) return;
                        const selectedField = dynamicFields?.[eachFieldKey];
                        updatedDynamicFields = { ...updatedDynamicFields, [eachFieldKey]: eachFieldValue };
                        if (
                            selectedField &&
                            (!_.isEqual(selectedField?.value, eachFieldValue?.value) || !_.isEqual(selectedField?.uuid, eachFieldValue?.uuid))
                        ) {
                            updatedLogFields = {
                                ...(updatedLogFields ?? {}),
                                [eachFieldKey]: {
                                    value: eachFieldValue?.value,
                                    uuid: eachFieldValue?.uuid,
                                    invalid: eachFieldValue?.invalid,
                                    old_value: {
                                        value: selectedField?.value,
                                        uuid: selectedField?.uuid,
                                        invalid: selectedField?.invalid,
                                        label: selectedField?.label
                                    }
                                }
                            };
                        }
                    });
                });
                const params = {
                    log_fields: updatedLogFields,
                    dynamic_fields: updatedDynamicFields,
                    ...(data?.has_check_list ? { check_list: denormalizeToFlat(data?.check_list ?? []) } : {})
                };
                updateDataRef.current = true;
                dispatch(mobileRecomActions.updateMobileRecommendationFields(id, params));
            }
        }
    };

    const validateForm = onChangeData => {
        const dataToBeValidated = onChangeData ?? data;
        const allFields = getVisibilityConditionFields(dataToBeValidated);
        let errorParams = {};
        let showErrorBorder = false;
        Object.values(dataToBeValidated).forEach(fields => {
            const clientStandardId = fields?.["assets.client_standards_id"]?.uuid;
            const clientStandardObject = (dropDownList?.client_standards || [])?.find(e => e?.id === clientStandardId) ?? {};
            const visibleFields = clientStandardObject?.visible_fields ?? [];

            Object.entries(fields ?? {}).forEach(([eachFieldKey, eachFieldValue]) => {
                const recommendationType = dataToBeValidated?.Recommendations?.recommendation_type?.value?.toLowerCase();
                if (!shouldShowField(eachFieldValue, allFields)) return;
                if (
                    eachFieldValue?.group_field === "Asset" &&
                    (recommendationType !== "asset" || recommendationType === "") &&
                    isMobileRecommendation
                )
                    return;
                const isOriginallyMandatory = eachFieldValue?.rules?.mandatory;
                const shouldValidate =
                    isOriginallyMandatory && (!Array.isArray(visibleFields) || visibleFields?.length === 0 || visibleFields?.includes(eachFieldKey));

                if (
                    shouldValidate &&
                    ((typeof eachFieldValue?.value === "string" && !eachFieldValue?.value?.trim()?.length) || !eachFieldValue?.value)
                ) {
                    errorParams[eachFieldKey] = `* ${eachFieldValue?.label} is required`;
                    showErrorBorder = true;
                }
            });
        });
        if (!showErrorBorder && isMobileRecommendation) {
            const { valid: checklistValid, errors: checklistErrors } = validateChecklists();
            if (!checklistValid) {
                const first = checklistErrors[0];
                showErrorBorder = true;
                errorParams["checklist"] = first.message || "Please fix checklist structure before saving.";
            }
        }
        setShowErrorBorder(showErrorBorder);
        setErrorParams(errorParams);
        if (showErrorBorder) return false;
        return true;
    };
    const validateChecklists = () => {
        const checkListData = data?.check_list;
        const errors = [];

        if (!Array.isArray(checkListData) || checkListData.length === 0) {
            return { valid: true, errors: [] };
        }
        checkListData.forEach(p => {
            const partyHasItems = Array.isArray(p.checklists) && p.checklists.length > 0;
            const subs = Array.isArray(p.subBands) ? p.subBands : [];
            const anySubHasItems = subs.some(s => Array.isArray(s.checklists) && s.checklists.length > 0);

            if (!partyHasItems && !anySubHasItems) {
                errors.push({
                    type: "party",
                    partyId: p.id,
                    message: `Checklist Error: Party "${p.title}" does not contain any checklist items.`
                });
            } else {
                subs.forEach(s => {
                    if (!Array.isArray(s.checklists) || s.checklists.length === 0) {
                        errors.push({
                            type: "subband",
                            partyId: p.id,
                            subId: s.id,
                            message: `Checklist Error: Sub-band "${s.title}" under party "${p.title}" does not contain any checklist items.`
                        });
                    }
                });
            }
        });

        return { valid: errors.length === 0, errors };
    };

    const onDirtyCheck = () => {
        if (!_.isEqual(data, initialData)) {
            dispatch(commonActions.setFormDirty(true));
        }
    };
    const onCancel = () => {
        if (!_.isEqual(data, initialData)) {
            setShowCancelConfirmModal(true);
            dispatch(commonActions.setFormDirty(false));
        } else cancelForm();
    };

    const cancelForm = () => {
        setInitialData({});
        setData({});
        setStaticData({});
        const currentBreadCrumbData = findInfoPathFromBreadCrump();
        if (currentBreadCrumbData?.length && currentBreadCrumbData?.[currentBreadCrumbData?.length - 1]?.isFromTable) {
            popBreadCrumpOnPageClose();
        }
        popBreadCrumpOnPageClose();
        history.push(findPrevPathFromBreadCrumpData());
    };

    const dependencyFields = (name, eachField) => {
        const fields = isMobileRecommendation
            ? {
                  region_id: ["site_id", "building_id", "floor", "addition_id", "main_building_type_id"],
                  site_id: ["building_id", "floor", "addition_id", "main_building_type_id"],
                  main_building_type_id: ["building_id", "floor", "addition_id"],
                  building_id: ["floor", "addition_id", "main_building_type_id"],
                  trade_id: ["system_id", "sub_system_id"],
                  system_id: ["sub_system_id"]
              }
            : {
                  "assets.region_id": ["assets.site_id", "assets.building_id", "assets.floor_id", "assets.addition_id", "buildings.description"],
                  "assets.site_id": ["assets.building_id", "assets.floor_id", "assets.addition_id", "buildings.description"],
                  "assets.building_id": ["assets.floor_id", "assets.addition_id"],
                  "assets.trade_id": ["assets.system_id", "assets.sub_system_id"],
                  "assets.system_id": ["assets.sub_system_id"],
                  "buildings.main_building_type_id": ["assets.building_id", "assets.floor_id", "assets.addition_id"],
                  "assets.main_category_id": ["assets.sub_category_1_id", "assets.sub_category_2_id", "assets.sub_category_3_id"],
                  "assets.sub_category_1_id": ["assets.sub_category_2_id", "assets.sub_category_3_id"],
                  "assets.sub_category_2_id": ["assets.sub_category_3_id"]
              };
        return fields?.[name]?.includes(eachField);
    };

    const getUniformatDescriptionKey = fieldName => fieldName?.match(/uniformat_level_\d+_description/)?.[0];

    const getUniformatDescriptionUpdate = (fieldValue, fieldName, changedLevelName, value) => {
        const fieldLevel = getUniformatLevel(fieldName);
        const changedLevel = getUniformatLevel(changedLevelName);
        const descriptionKey = getUniformatDescriptionKey(fieldName);
        if (!fieldLevel || !changedLevel || !descriptionKey) return fieldValue;

        const selectedUniformat = uniformatList?.[changedLevelName]?.find(e => e?.id === value) ?? "";
        const shouldClear = (!value && fieldLevel >= changedLevel) || fieldLevel > changedLevel;
        const uniformat =
            fieldLevel === changedLevel
                ? selectedUniformat
                : uniformatList?.[`assets.uniformat_level_${fieldLevel}_id`]?.find(
                      e => e?.id === selectedUniformat?.[`assets.uniformat_level_${fieldLevel}_id`]
                  );
        return {
            ...fieldValue,
            uuid: "",
            value: shouldClear ? "" : (uniformat?.[fieldName] ?? uniformat?.[descriptionKey] ?? ""),
            invalid: false
        };
    };

    const findFieldInState = (state, fieldName) => {
        let field;
        Object.values(state ?? {}).forEach(bandFields => {
            if (!bandFields || Array.isArray(bandFields)) return;
            if (bandFields?.[fieldName]) field = bandFields?.[fieldName];
        });
        return field;
    };

    const isFieldVisibleInState = (state, fieldName) => {
        const field = findFieldInState(state, fieldName);
        if (!field) return false;
        return shouldShowField(field, getVisibilityConditionFields(state));
    };

    const withUniformatSelection = (state, fieldName, value) => {
        const option = uniformatList?.[fieldName]?.find(e => e?.id === value);
        return Object.fromEntries(
            Object.entries(state ?? {}).map(([bandKey, bandFields]) =>
                !bandFields || Array.isArray(bandFields) || !bandFields?.[fieldName]
                    ? [bandKey, bandFields]
                    : [bandKey, { ...bandFields, [fieldName]: { ...bandFields[fieldName], uuid: value ?? "", value: option?.label ?? "" } }]
            )
        );
    };

    const getFormUniformatAutoValues = (fieldName, value, state = data) => {
        if (!value) return {};
        const option = uniformatList?.[fieldName]?.find(e => e?.id === value);
        return getUniformatAutoValues(option, fieldName, field => isFieldVisibleInState(state, field));
    };

    const getPendingUniformatChange = (fieldName, value, args) => {
        const stateAfterChange = withUniformatSelection(data, fieldName, value);
        const autoValues = getFormUniformatAutoValues(fieldName, value, stateAfterChange);
        const summary = getUniformatChangeSummary(autoValues, field => findFieldInState(data, field)?.value);
        if (!summary) return null;
        return {
            args,
            ...summary,
            source: {
                from: findFieldInState(data, fieldName)?.value,
                to: uniformatList?.[fieldName]?.find(e => e?.id === value)?.label ?? ""
            },
            current: {
                serviceLife: findFieldInState(data, SERVICE_LIFE_FIELD)?.value,
                capacityUnit: findFieldInState(data, CAPACITY_UNIT_FIELD)?.value,
                criticality: findFieldInState(data, CRITICALITY_FIELD)?.value,
                installedYear: findFieldInState(data, INSTALLED_YEAR_FIELD)?.value,
                usefulLifeRemaining: findFieldInState(data, USEFUL_LIFE_REMAINING_FIELD)?.value,
                hasInstalledYearField: isFieldVisibleInState(stateAfterChange, INSTALLED_YEAR_FIELD),
                hasEndOfServiceLifeField: isFieldVisibleInState(stateAfterChange, END_OF_SERVICE_LIFE_FIELD),
                hasUsefulLifeRemainingField: isFieldVisibleInState(stateAfterChange, USEFUL_LIFE_REMAINING_FIELD),
                hasCurrentAgeField: isFieldVisibleInState(stateAfterChange, CURRENT_AGE_FIELD)
            }
        };
    };

    const applyUniformatAutoValues = (state, values = {}) => {
        if (!Object.keys(values ?? {}).length) return state;
        const allFields = getVisibilityConditionFields(state);
        const derivedValues = getUniformatValuesWithDerivedFields(values, field => {
            const stateField = findFieldInState(state, field);
            return shouldShowField(stateField, allFields) ? stateField?.value : undefined;
        });
        return Object.fromEntries(
            Object.entries(state ?? {}).map(([bandKey, bandFields]) => {
                if (!bandFields || Array.isArray(bandFields)) return [bandKey, bandFields];
                let updatedFields = bandFields;
                Object.entries(derivedValues).forEach(([fieldKey, fieldValue]) => {
                    if (updatedFields?.[fieldKey] && shouldShowField(updatedFields?.[fieldKey], allFields)) {
                        updatedFields = {
                            ...updatedFields,
                            [fieldKey]: { ...updatedFields[fieldKey], value: fieldValue, uuid: "", invalid: false }
                        };
                    }
                });
                return [bandKey, updatedFields];
            })
        );
    };

    const getMobileRecomLifecycleKeys = (state = data) =>
        getRecommendationLifecycleFieldKeys(state?.Recommendations?.recommendation_type?.value?.toLowerCase() === "asset");

    const getSubsystemServiceLifeValues = (value, state = data) => {
        const keys = getMobileRecomLifecycleKeys(state);
        if (!value || !isFieldVisibleInState(state, keys.serviceLife)) return {};
        const serviceLife = getMobileRecommendationDropdownResponse?.sub_system_id?.find(e => e?.id === value)?.service_life;
        return serviceLife === null || serviceLife === undefined || serviceLife === "" ? {} : { [keys.serviceLife]: serviceLife };
    };

    const getPendingSubsystemChange = (value, args) => {
        const keys = getMobileRecomLifecycleKeys();
        if (!value || !isFieldVisibleInState(data, keys.serviceLife)) return null;
        const subSystem = getMobileRecommendationDropdownResponse?.sub_system_id?.find(e => e?.id === value);
        const summary = getSubsystemServiceLifeChangeSummary({
            subSystem,
            serviceLifeKey: keys.serviceLife,
            currentServiceLife: findFieldInState(data, keys.serviceLife)?.value
        });
        if (!summary) return null;
        return {
            args,
            ...summary,
            source: { from: findFieldInState(data, "sub_system_id")?.value, to: subSystem?.name ?? subSystem?.label ?? "" },
            current: {
                serviceLife: findFieldInState(data, keys.serviceLife)?.value,
                installedYear: findFieldInState(data, keys.installedYear)?.value,
                usefulLifeRemaining: findFieldInState(data, keys.usefulLifeRemaining)?.value,
                hasInstalledYearField: isFieldVisibleInState(data, keys.installedYear),
                hasEndOfServiceLifeField: isFieldVisibleInState(data, keys.endOfServiceLife),
                hasUsefulLifeRemainingField: isFieldVisibleInState(data, keys.usefulLifeRemaining)
            }
        };
    };

    const applySubsystemServiceLife = (state, values = {}) => {
        const keys = getMobileRecomLifecycleKeys(state);
        if (!(keys.serviceLife in (values ?? {}))) return state;
        const allFields = getVisibilityConditionFields(state);
        const serviceLife = values[keys.serviceLife] ?? "";
        const installedYearField = findFieldInState(state, keys.installedYear);
        const installedYear = shouldShowField(installedYearField, allFields) ? installedYearField?.value : undefined;
        const derivedValues = {
            [keys.serviceLife]: serviceLife,
            [keys.usefulLifeRemaining]: getUsefullLifeRemaining(installedYear, serviceLife),
            [keys.endOfServiceLife]: getEndOfServiceLife(installedYear, serviceLife)
        };
        return Object.fromEntries(
            Object.entries(state ?? {}).map(([bandKey, bandFields]) => {
                if (!bandFields || Array.isArray(bandFields)) return [bandKey, bandFields];
                let updatedFields = bandFields;
                Object.entries(derivedValues).forEach(([fieldKey, fieldValue]) => {
                    if (updatedFields?.[fieldKey] && shouldShowField(updatedFields?.[fieldKey], allFields)) {
                        updatedFields = { ...updatedFields, [fieldKey]: { ...updatedFields[fieldKey], value: fieldValue, uuid: "", invalid: false } };
                    }
                });
                return [bandKey, updatedFields];
            })
        );
    };

    const applyPendingServiceLifeValues = values => {
        const { sourceField } = pendingServiceLifeChange;
        setData(prevData =>
            sourceField === "sub_system_id" ? applySubsystemServiceLife(prevData, values) : applyUniformatAutoValues(prevData, values)
        );
    };

    const handleServiceLifeChangeApply = selectedFields => {
        if (!pendingServiceLifeChange) return;
        const selectedValues = Object.fromEntries(
            Object.entries(pendingServiceLifeChange?.values ?? {}).filter(([field]) => selectedFields?.includes(field))
        );
        if (Object.keys(selectedValues).length) applyPendingServiceLifeValues(selectedValues);
        setPendingServiceLifeChange(null);
    };

    const priorityTotalCalculation = (datas, name, valueObject) => {
        const updatedPriorityData = {
            ...(datas?.Priority || {}),
            [name]: {
                ...(datas?.Priority?.[name] || {}),
                ...valueObject
            }
        };
        const filteredPriorityElements = Object.entries(updatedPriorityData)
            .filter(([key, val]) => val?.hasOwnProperty("priority_element_option"))
            .map(([key, val]) => ({
                id: key,
                ...val
            }));

        const priorityTotal = filteredPriorityElements.reduce((sum, item) => sum + (Number(item.priority_element_option) || 0), 0);
        const criticalityData = getMobileRecommendationDropdownResponse?.["criticality_id"];
        let criticalityId = data?.Priority?.criticality_id?.uuid;
        let criticalityValue = data?.Priority?.criticality_id?.value;
        const cs = getProjectByIdResponse?.miscellaneous?.criticality_score;

        if (cs !== "year" && priorityTotal > 0 && criticalityData?.length) {
            const match = criticalityData.find(c => priorityTotal >= Number(c?.start_range) && priorityTotal <= Number(c?.end_range));
            criticalityId = match?.id || "";
            criticalityValue = match?.name;
        }
        return { priorityTotal, newCriticalityId: { id: criticalityId, name: criticalityValue } };
    };
    const shouldAutoPopulate = (changedName, fieldKey) => {
        const currentFields = Object.values(data || {}).reduce((acc, item) => {
            acc = [...acc, ...Object.values(item)];
            return acc;
        }, []);
        return (currentFields ?? []).find(e => e?.field_name === changedName)?.auto_populate_fields?.includes(fieldKey) ?? false;
    };
    const applyAutoPopulateGlobally = (state, changedName = [], shouldSetData = false) => {
        let updatedState = Object.fromEntries(
            Object.entries(state ?? data ?? {})?.map(([bandName, band]) => [bandName, Array.isArray(band) ? [...band] : { ...band }])
        );

        let autoPopulateValue = null;
        for (const band of Object.values(updatedState || {})) {
            if (band?.[changedName]) {
                autoPopulateValue = band[changedName]?.value ?? null;
                break;
            }
        }

        Object.entries(updatedState).forEach(([bandName, band]) => {
            if (Array.isArray(band)) return;
            Object.keys(band || {}).forEach(fieldKey => {
                if (fieldKey === changedName) return;

                const should = shouldAutoPopulate(changedName, fieldKey);

                if (should) {
                    const invalid = ["custom_select", "select"].includes(band[fieldKey]?.field_type);

                    updatedState[bandName][fieldKey] = {
                        ...band[fieldKey],
                        value: autoPopulateValue,
                        uuid: "",
                        invalid
                    };
                }
            });
        });

        if (shouldSetData) setData(updatedState);
        else return updatedState;
    };

    const clearHiddenFieldValues = state => {
        let updatedState = state;
        let hasClearedField = true;

        while (hasClearedField) {
            hasClearedField = false;
            const allFields = getVisibilityConditionFields(updatedState);

            Object.entries(updatedState ?? {}).forEach(([bandKey, bandFields]) => {
                if (!bandFields || Array.isArray(bandFields)) return;

                let clearedFields = {};
                Object.entries(bandFields).forEach(([fieldKey, field]) => {
                    if (!field || typeof field !== "object") return;
                    if (!field?.visibility_condition?.all?.length && !field?.parent_fields?.length) return;

                    const hasValue = !!field?.uuid || (field?.value !== "" && field?.value !== null && field?.value !== undefined);
                    if (!hasValue || shouldShowField(field, allFields)) return;

                    clearedFields = { ...clearedFields, [fieldKey]: { ...field, value: "", uuid: "", invalid: false } };
                });

                if (Object.keys(clearedFields).length) {
                    updatedState = { ...updatedState, [bandKey]: { ...bandFields, ...clearedFields } };
                    hasClearedField = true;
                }
            });
        }

        return updatedState;
    };

    const handleChange = (e, isCreatedBuilding, isNewField = false, shouldApplyAutoPopulate = false) => {
        const { name, value, responseName = "" } = e;

        let pendingChange = null;
        if (!isMobileRecommendation && name?.startsWith("assets.uniformat_level_")) {
            pendingChange = getPendingUniformatChange(name, value, [e, isCreatedBuilding, isNewField, shouldApplyAutoPopulate]);
        }
        if (isMobileRecommendation && name === "sub_system_id") {
            pendingChange = getPendingSubsystemChange(value, [e, isCreatedBuilding, isNewField, shouldApplyAutoPopulate]);
        }
        const isAssetType = data?.Recommendations?.recommendation_type?.value?.toLowerCase() === "asset";
        const priorityField = Object.keys(data?.Priority || {})?.find(val => val === e?.name);
        const PriorityFieldValue = priorityField ? Object.keys(data.Priority[priorityField] || {})?.includes("priority_element_option") : null;

        let changedObject = data;

        const findField = field => {
            let allFields = {};
            Object?.values(changedObject ?? {})?.forEach(each => {
                allFields = { ...allFields, ...each };
            });
            return allFields?.[field];
        };
        //visibility condition check for changed field
        const shouldShowChangedField = (bandKey, bandFields, changedFields, fieldKey) => {
            const currentBandFields = {
                ...bandFields,
                ...changedFields,
                ...(bandFields?.[name] && {
                    [name]: {
                        ...bandFields?.[name],
                        ...(changedFields?.[name] || {}),
                        value
                    }
                })
            };
            const allFields = getVisibilityConditionFields({ ...changedObject, [bandKey]: currentBandFields });
            return shouldShowField(currentBandFields?.[fieldKey], allFields);
        };

        if (name === "check_list" && isMobileRecommendation) {
            changedObject = { ...changedObject, check_list: value };
        } else
            Object.entries(changedObject ?? {}).forEach(([eachFieldKey, eachFieldValue]) => {
                let changedFields = {};
                Object.keys(eachFieldValue ?? {}).forEach(eachField => {
                    if (name === eachField) {
                        const isInvalid = value && initialData?.[eachFieldKey]?.[eachField]?.value === value && isNewField;
                        const isCustomField = eachFieldValue?.[eachField]?.field_type === "custom_select";
                        const isSelectField = eachFieldValue?.[eachField]?.field_type === "select";
                        const uniformatNames = [
                            "assets.uniformat_level_6_id",
                            "assets.uniformat_level_5_id",
                            "assets.uniformat_level_4_id",
                            "assets.uniformat_level_3_id",
                            "assets.uniformat_level_2_id",
                            "assets.uniformat_level_1_id"
                        ];
                        let valueObject = {
                            uuid: isInvalid || !isCustomField ? "" : value,
                            value: responseName
                                ? responseName
                                : isInvalid || !isCustomField
                                ? value
                                : isMobileRecommendation
                                ? eachField === "recommendation_status_id"
                                    ? getStatusDropdwnResponse?.recommendation_status_data?.find(e => e?.id === value)?.name
                                    : eachField === "manufacturer_id" ||
                                      eachField === "assets.manufacturer_id" ||
                                      eachField === "asset_conditions" ||
                                      eachField === "assets.client_asset_condition_id"
                                    ? dropDownList?.[dropdownKeys?.[eachField]]?.find(e => e?.id === value)?.name
                                    : eachField === "recommendation_capital_type_id"
                                    ? getMobileRecommendationDropdownResponse?.[eachField]?.find(e => e?.id === value)?.display_name
                                    : getMobileRecommendationDropdownResponse?.[eachField]?.find(e => e?.id === value)?.name
                                : uniformatNames?.includes(name)
                                ? uniformatList?.[name]?.find(e => e?.id === value)?.label
                                : dropDownList?.[dropdownKeys?.[eachField]]?.find(e => e?.id === value)?.name,
                            invalid: isInvalid && (isCustomField || isSelectField) ? true : false,
                        };
                        if (!value && isCustomField) valueObject = { value: "", uuid: "", invalid: false };
                        if (PriorityFieldValue && isMobileRecommendation) {
                            const priorityDropdownList = priorityElementsDropDownResponse?.priority_elements
                                ?.find(e => e?.id === name)
                                ?.options?.find(priority => priority?.id === value);
                            valueObject = {
                                uuid: priorityDropdownList?.id,
                                value: priorityDropdownList?.name,
                                priority_element_option: priorityDropdownList?.value
                            };
                        }
                        changedFields = { ...changedFields, [eachField]: { ...eachFieldValue?.[eachField], ...valueObject } };
                        if (isCustomField && (!isInvalid || (isMobileRecommendation && ["trade_id", "system_id", "sub_system_id"]?.includes(name))))
                            onInputChangeDropdownUpdates(name, value);
                    } else if (eachField === "criticality_id" && isMobileRecommendation && priorityField) {
                        const priorityDropdownList = priorityElementsDropDownResponse?.priority_elements
                            ?.find(e => e?.id === name)
                            ?.options?.find(priority => priority?.id === value);
                        const priorityObject = {
                            uuid: priorityDropdownList?.id,
                            value: priorityDropdownList?.name,
                            priority_element_option: priorityDropdownList?.value
                        };
                        const newCriticality = priorityTotalCalculation(data, name, priorityObject)?.newCriticalityId;
                        changedFields = {
                            ...changedFields,
                            ["criticality_id"]: {
                                ...eachFieldValue?.["criticality_id"],
                                value: newCriticality?.name ?? "",
                                uuid: newCriticality?.id ?? "",
                                invalid: false
                            }
                        };
                    } else if (eachField === "priority" && isMobileRecommendation && priorityField) {
                        const priorityDropdownList = priorityElementsDropDownResponse?.priority_elements
                            ?.find(e => e?.id === name)
                            ?.options?.find(priority => priority?.id === value);
                        const priorityObject = {
                            uuid: priorityDropdownList?.id,
                            value: priorityDropdownList?.name,
                            priority_element_option: priorityDropdownList?.value
                        };
                        const priorityTotal = priorityTotalCalculation(data, name, priorityObject)?.priorityTotal;
                        changedFields = {
                            ...changedFields,
                            ["priority"]: { ...eachFieldValue?.["priority"], value: priorityTotal }
                        };
                    } else if (
                        (name === "building_id" && eachField === "main_building_type_id") ||
                        (name === "assets.building_id" && eachField === "buildings.main_building_type_id")
                    ) {
                        if (
                            (eachFieldValue?.[eachField]?.invalid &&
                                (!value ||
                                    Object.values(initialData ?? {}).some(
                                        e => e?.[isMobileRecommendation ? "building_id" : "assets.building_id"]?.value === value
                                    ))) ||
                            isCreatedBuilding
                        )
                            changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                        else {
                            const { building_type_id = "", description = "" } =
                                getMobileRecommendationDropdownResponse?.building_id?.find(e => e?.id === value) ?? {};
                            const { id: main_building_type_id = "", name: main_building_type_name = "" } =
                                dropDownList?.[dropdownKeys?.[eachField]]?.find(e =>
                                    dropDownList?.[dropdownKeys?.[name]]?.some(item => item?.main_building_type_id === e?.id && item?.id === value)
                                ) ?? {};
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    uuid: isMobileRecommendation ? building_type_id : main_building_type_id,
                                    value: isMobileRecommendation ? description : main_building_type_name,
                                    invalid: false
                                }
                            };
                        }
                    } else if (name === "assets.building_id" && eachField === "buildings.description") {
                        {
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    value: dropDownList?.["buildings"]?.find(e => e?.id === value)?.description ?? "",
                                    invalid: false
                                }
                            };
                        }
                    } else if (name === "system_id" && eachField === "trade_id") {
                        if (!value || isCreatedBuilding || Object.values(initialData ?? {}).some(e => e?.["system_id"]?.value === value))
                            changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                        else {
                            const { trade_id = "", trade_name = "" } =
                                getMobileRecommendationDropdownResponse?.[name]?.find(e => e?.id === value) ?? {};
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    uuid: trade_id,
                                    value: trade_name,
                                    invalid: false
                                }
                            };
                        }
                    } else if (["trade_id", "system_id"].includes(eachField) && name === "sub_system_id") {
                        if (!value || isCreatedBuilding || Object.values(initialData ?? {}).some(e => e?.["sub_system_id"]?.value === value))
                            changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                        else {
                            const {
                                system_id = "",
                                system_name = "",
                                trade_id = "",
                                trade_name = ""
                            } = getMobileRecommendationDropdownResponse?.[name]?.find(e => e?.id === value) ?? {};
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    uuid: eachField === "system_id" ? system_id : trade_id,
                                    value: eachField === "system_id" ? system_name : trade_name,
                                    invalid: false
                                }
                            };
                        }
                    } else if (["assets.installed_year", "installed_year"].includes(name) && eachField !== name) {
                        const showCalculatedField = shouldShowChangedField(eachFieldKey, eachFieldValue, changedFields, eachField);
                        if (
                            ["assets.usefull_life_remaining", "usefull_life_remaining"].includes(eachField) &&
                            showCalculatedField &&
                            findField(isMobileRecommendation ? (!isAssetType ? "service_life" : "assets.service_life") : "assets.service_life")
                        ) {
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    value: getUsefullLifeRemaining(
                                        value,
                                        findField(
                                            isMobileRecommendation ? (!isAssetType ? "service_life" : "assets.service_life") : "assets.service_life"
                                        )?.value
                                    )
                                }
                            };
                        } else if (
                            ["assets.end_of_service_life", "end_of_service_life"].includes(eachField) &&
                            showCalculatedField &&
                            findField(isMobileRecommendation ? (!isAssetType ? "service_life" : "assets.service_life") : "assets.service_life")
                        ) {
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    value: getEndOfServiceLife(
                                        value,
                                        findField(
                                            isMobileRecommendation ? (!isAssetType ? "service_life" : "assets.service_life") : "assets.service_life"
                                        )?.value
                                    )
                                }
                            };
                        } else if (["assets.current_age", "current_age"].includes(eachField) && showCalculatedField) {
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    value: getCurrentAge(value)
                                }
                            };
                        } else changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                    } else if (["assets.service_life", "service_life"].includes(name) && eachField !== name) {
                        const showCalculatedField = shouldShowChangedField(eachFieldKey, eachFieldValue, changedFields, eachField);
                        if (
                            ["assets.usefull_life_remaining", "usefull_life_remaining"].includes(eachField) &&
                            showCalculatedField &&
                            findField(isMobileRecommendation ? (!isAssetType ? "installed_year" : "assets.installed_year") : "assets.installed_year")
                        ) {
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    value: getUsefullLifeRemaining(
                                        findField(
                                            isMobileRecommendation
                                                ? !isAssetType
                                                    ? "installed_year"
                                                    : "assets.installed_year"
                                                : "assets.installed_year"
                                        )?.value,
                                        value
                                    )
                                }
                            };
                        } else if (
                            ["assets.end_of_service_life", "end_of_service_life"].includes(eachField) &&
                            showCalculatedField &&
                            findField(isMobileRecommendation ? (!isAssetType ? "installed_year" : "assets.installed_year") : "assets.installed_year")
                        ) {
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    value: getEndOfServiceLife(
                                        findField(
                                            isMobileRecommendation
                                                ? !isAssetType
                                                    ? "installed_year"
                                                    : "assets.installed_year"
                                                : "assets.installed_year"
                                        )?.value,
                                        value
                                    )
                                }
                            };
                        } else changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                    } else if (name?.startsWith("assets.uniformat_level_") && getUniformatDescriptionKey(eachField)) {
                        changedFields = {
                            ...changedFields,
                            [eachField]: getUniformatDescriptionUpdate(eachFieldValue?.[eachField], eachField, name, value)
                        };
                    } else if (name?.startsWith("assets.uniformat_level_") && eachField !== name) {
                        const levels = [
                            "assets.uniformat_level_6_id",
                            "assets.uniformat_level_5_id",
                            "assets.uniformat_level_4_id",
                            "assets.uniformat_level_3_id",
                            "assets.uniformat_level_2_id",
                            "assets.uniformat_level_1_id"
                        ];

                        levels.forEach(level => {
                            if (eachField === level && findField(level)) {
                                const uniformData = uniformatList?.[name]?.find(e => e?.id === value);
                                changedFields = {
                                    ...changedFields,
                                    [eachField]: {
                                        ...eachFieldValue?.[eachField],
                                        uuid: uniformData?.[eachField],
                                        value: uniformatList?.[eachField]?.find(e => e?.id === uniformData?.[eachField])?.label
                                    }
                                };
                            }
                        });

                        if (!levels.includes(eachField)) {
                            changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                        }
                    } else if (name === "assets.client_standards_id" && eachField !== name) {
                        const levels = [
                            "entity",
                            "assets.survey_target_id",
                            "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id",
                            "assets.uniformat_level_6_id",
                            "assets.uniformat_level_5_id",
                            "assets.uniformat_level_4_id",
                            "assets.uniformat_level_3_id",
                            "assets.uniformat_level_2_id",
                            "assets.uniformat_level_1_id",
                            "assets.csp_unit",
                            "assets.service_life",
                            "assets.client_standards__description"
                            // surveyProject?.client_id === "06356c0e-2ad9-4af8-8992-83e35233f7d4"||
                            // surveyProject?.client_id === "300a3a47-20d4-46a8-bf9d-f7bde51bff62"
                            //     ? "assets.asset_name"
                            //     : ""
                        ];

                        const clientStandardKeys = {
                            "assets.csp_unit": "assets.csp_unit",
                            "assets.service_life": "assets.service_life",
                            "assets.client_standards__description": "description",
                            "assets.uniformat_level_1_id": "uniformat_level_1_id",
                            "assets.uniformat_level_2_id": "uniformat_level_2_id",
                            "assets.uniformat_level_3_id": "uniformat_level_3_id",
                            "assets.uniformat_level_4_id": "uniformat_level_4_id",
                            "assets.uniformat_level_5_id": "uniformat_level_5_id",
                            "assets.uniformat_level_6_id": "uniformat_level_6s_id"
                        };
                        const entityLevels = {
                            entity: "entity",
                            "assets.survey_target_id": "assets.survey_target_id",
                            "assets.cs_l1_type_id": "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id": "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id": "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id": "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id": "assets.cs_l5_equipment_config_id",
                            "assets.asset_name": "assets.asset_name"
                        };
                        const clientStandardObject = dropDownList?.client_standards?.find(e => e?.id === value);
                        levels.forEach(level => {
                            if (eachField === level && findField(level)) {
                                const isEntityObject = entityLevels?.[level];

                                let uniformName = "";
                                let uniformId = "";

                                if (isEntityObject) {
                                    const fieldKey = level === "entity" ? "assets.survey_target_id" : level;
                                    const clientStandardValue = clientStandardObject?.[fieldKey];
                                    if (level === "assets.asset_name") {
                                        changedFields = {
                                            ...changedFields,
                                            [eachField]: {
                                                ...eachFieldValue?.[eachField],
                                                uuid: "",
                                                value: clientStandardObject?.name || ""
                                            }
                                        };
                                        return;
                                    }
                                    if (!clientStandardValue) {
                                        changedFields = {
                                            ...changedFields,
                                            [eachField]: eachFieldValue?.[eachField]
                                        };
                                        return;
                                    }

                                    const selectedData = getStaticDropdownValues?.data?.[fieldKey]?.find(e => e?.id === clientStandardValue);
                                    uniformName = level === "assets.asset_name" ? clientStandardObject?.name : selectedData?.name || "";
                                    uniformId = level === "assets.asset_name" ? "" : selectedData?.id || "";
                                } else {
                                    const rawId = clientStandardObject?.[clientStandardKeys?.[eachField]];
                                    const matched = uniformatList?.[eachField]?.find(e => e?.id === rawId);
                                    uniformName = matched?.label || "";
                                    uniformId = matched?.id || "";
                                }
                                changedFields = {
                                    ...changedFields,
                                    [eachField]: {
                                        ...eachFieldValue?.[eachField],
                                        uuid: uniformId ? uniformId : "",
                                        value: uniformName ? uniformName : (clientStandardObject?.[clientStandardKeys?.[eachField]] ?? "")
                                    }
                                };
                            }
                        });

                        if (getUniformatDescriptionKey(eachField)) {
                            const selectedUniformatLevel = levels.find(
                                level => level?.startsWith("assets.uniformat_level_") && clientStandardObject?.[clientStandardKeys?.[level]]
                            );
                            changedFields = {
                                ...changedFields,
                                [eachField]: getUniformatDescriptionUpdate(
                                    eachFieldValue?.[eachField],
                                    eachField,
                                    selectedUniformatLevel || "assets.uniformat_level_1_id",
                                    clientStandardObject?.[clientStandardKeys?.[selectedUniformatLevel]] || ""
                                )
                            };
                        } else if (!levels.includes(eachField)) {
                            changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                        }
                    } else if (
                        dependencyFields(name, eachField) &&
                        (!eachFieldValue?.[eachField]?.invalid ||
                            (isMobileRecommendation && ["trade_id", "system_id", "sub_system_id"]?.includes(name)))
                    ) {
                        changedFields = {
                            ...changedFields,
                            [eachField]: { ...eachFieldValue?.[eachField], value: "", uuid: "", invalid: false }
                        };
                    } else if (name?.startsWith("assets.cs_") || name === "entity") {
                        const levels = [
                            "assets.survey_target_id",
                            "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id",
                            "assets.client_standards_id",
                            "assets.asset_name"
                            // surveyProject?.client_id === "06356c0e-2ad9-4af8-8992-83e35233f7d4" ||
                            // surveyProject?.client_id === "300a3a47-20d4-46a8-bf9d-f7bde51bff62"
                            //     ? "assets.asset_name"
                            //     : ""
                        ];

                        const normalizedChangedName = name === "entity" ? "assets.survey_target_id" : name;
                        const normalizedEachField = eachField === "entity" ? "assets.survey_target_id" : eachField;

                        const changedLevelIndex = levels.indexOf(normalizedChangedName);
                        const currentLevelIndex = levels.indexOf(normalizedEachField);

                        const selectedData = getStaticDropdownValues?.data?.[normalizedChangedName]?.find(e => e?.id === value);

                        if (changedLevelIndex === -1 || currentLevelIndex === -1) {
                            changedFields = {
                                ...changedFields,
                                [eachField]: eachFieldValue?.[eachField]
                            };
                            return;
                        }

                        const parentId = selectedData?.[normalizedEachField];

                        if (currentLevelIndex < changedLevelIndex && findField(eachField) && parentId) {
                            const dropdownData = getStaticDropdownValues?.data?.[normalizedEachField] ?? [];
                            const matched = dropdownData.find(e => e?.id === parentId);
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    uuid: parentId ?? "",
                                    value: matched?.name ?? ""
                                }
                            };
                        } else if (currentLevelIndex > changedLevelIndex && findField(eachField)) {
                            changedFields = {
                                ...changedFields,
                                [eachField]: {
                                    ...eachFieldValue?.[eachField],
                                    uuid: "",
                                    value: ""
                                }
                            };
                        } else {
                            changedFields = {
                                ...changedFields,
                                [eachField]: eachFieldValue?.[eachField]
                            };
                        }
                    } else if (name === "assets.client_asset_condition_id" && eachField === "assets.client_asset_condition__description") {
                        changedFields = {
                            ...changedFields,
                            [eachField]: {
                                ...eachFieldValue?.[eachField],
                                value: dropDownList?.["asset_conditions"]?.find(e => e?.id === value)?.description ?? "",
                                invalid: false
                            }
                        };
                    } else changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
                });
                changedObject = {
                    ...changedObject,
                    [eachFieldKey]: eachFieldKey === "check_list" && isMobileRecommendation ? (data?.check_list ?? []) : { ...changedFields }
                };
            });
        if (!pendingChange && !isMobileRecommendation && name?.startsWith("assets.uniformat_level_")) {
            changedObject = applyUniformatAutoValues(changedObject, getFormUniformatAutoValues(name, value, changedObject));
        }
        if (!pendingChange && isMobileRecommendation && name === "sub_system_id") {
            changedObject = applySubsystemServiceLife(changedObject, getSubsystemServiceLifeValues(value, changedObject));
        }
        if (shouldApplyAutoPopulate) changedObject = applyAutoPopulateGlobally(changedObject, name);
        changedObject = clearHiddenFieldValues(changedObject);

        setData({ ...changedObject });
        if (pendingChange) setPendingServiceLifeChange({ ...pendingChange, previousData: data });
    };

    const clearPendingServiceLifeChange = () => {
        if (pendingServiceLifeChange?.previousData) setData(pendingServiceLifeChange.previousData);
        setPendingServiceLifeChange(null);
    };

    const fieldUUIDExists = field => {
        let UUID = "";
        Object.values(initialState ?? {}).forEach(fields => {
            Object.keys(fields ?? {}).forEach(eachFieldKey => {
                if (eachFieldKey === field) UUID = fields?.[eachFieldKey]?.uuid;
            });
        });
        return UUID;
    };

    const dataUUIDExists = field => {
        let UUID = "";
        Object.values(data ?? {}).forEach(fields => {
            Object.keys(fields ?? {}).forEach(eachFieldKey => {
                if (eachFieldKey === field) UUID = fields?.[eachFieldKey]?.uuid || fields?.[eachFieldKey]?.value;
            });
        });
        return UUID;
    };

    const fillEmptyFields = fields => {
        let changedObject = data;
        Object.entries(changedObject ?? {}).forEach(([eachFieldKey, eachFieldValue]) => {
            let changedFields = {};
            Object.keys(eachFieldValue ?? {}).forEach(eachField => {
                const suggestionValue = (getSuggestionDropdown?.data ?? [])?.find(e => e?.key === eachField)?.value;
                if (
                    fields?.includes(eachField) &&
                    !eachFieldValue?.[eachField]?.rules?.read_only &&
                    eachFieldValue?.[eachField]?.field_type === "text" &&
                    !eachFieldValue?.[eachField]?.value &&
                    (!suggestionValue || (suggestionValue && suggestionValue?.includes("NA")))
                ) {
                    changedFields = { ...changedFields, [eachField]: { ...eachFieldValue?.[eachField], value: "NA" } };
                } else changedFields = { ...changedFields, [eachField]: eachFieldValue?.[eachField] };
            });
            changedObject = { ...changedObject, [eachFieldKey]: { ...changedFields } };
        });
        setData(changedObject);
    };
    const getValidId = (...values) => values.find(v => v !== undefined && v !== null && v !== "") ?? null;

    const onInputChangeDropdownUpdates = (fieldName, value) => {
        const { client_id = "" } = surveyProject ?? {};

        const fieldDropdowns = isMobileRecommendation
            ? {
                  region_id: ["site_id"],
                  site_id: ["building_id"],
                  building_id: ["floor", "addition_id", "main_building_type_id"],
                  trade_id: ["system_id", "sub_system_id"],
                  system_id: ["sub_system_id", "system_id"],
                  sub_system_id: ["system_id", "sub_system_id"]
              }
            : {
                  "assets.region_id": ["sites"],
                  "assets.site_id": ["buildings"],
                  "assets.building_id": ["floors", "additions"],
                  "assets.trade_id": ["systems"],
                  "assets.system_id": ["sub_systems"],
                  "assets.main_category_id": ["sub_category_1s", "sub_category_2s", "sub_category_3s"],
                  "assets.sub_category_1_id": ["sub_category_2s", "sub_category_3s"],
                  "assets.sub_category_2_id": ["sub_category_3s"]
              };

        const paramKeys = isMobileRecommendation
            ? {
                  region_id: "region_id",
                  site_id: "site_id",
                  building_id: "building_id",
                  trade_id: "trade_id",
                  system_id: "system_id",
                  main_building_type_id: "main_building_type_id"
              }
            : {
                  "assets.site_id": "site_id",
                  "assets.region_id": "region_id",
                  "assets.building_id": "building_id",
                  "assets.trade_id": "trade_id",
                  "assets.system_id": "system_id",
                  "assets.main_category_id": "main_category_id",
                  "assets.sub_category_1_id": "sub_category_1_id",
                  "assets.sub_category_2_id": "sub_category_2_id"
              };

        let params = { [paramKeys?.[fieldName]]: value };
        if (
            [
                "assets.trade_id",
                "assets.system_id",
                "assets.region_id",
                "assets.site_id",
                "assets.building_id",
                "assets.main_category_id",
                "assets.sub_category_1_id",
                "assets.sub_category_2_id"
            ]?.includes(fieldName)
        )
            params = { ...params, client_id };
        const categoryHierarchy = ["assets.main_category_id", "assets.sub_category_1_id", "assets.sub_category_2_id", "assets.sub_category_3_id"];

        if (categoryHierarchy.includes(fieldName)) {
            const index = categoryHierarchy.indexOf(fieldName);

            const hierarchyParams = categoryHierarchy.slice(0, index).reduce((acc, key) => {
                const val = dataUUIDExists(key);
                if (val) acc[key.replace("assets.", "")] = val;
                return acc;
            }, {});

            params = {
                ...params,
                ...hierarchyParams,
                client_id
            };
        }
        const isGeoHeirarchyFields = ["floors", "additions", "buildings", "sites"];
        const clientId = queryParam?.c_id;
        const selectedSubSystem = getMobileRecommendationDropdownResponse?.["sub_system_id"]?.find(e => e?.id === value) ?? {};
        const trade_id = dataUUIDExists("trade_id");
        const selectedSystem = getMobileRecommendationDropdownResponse?.["system_id"]?.find(e => e?.id === value) ?? {};
        const system_id = dataUUIDExists("system_id");
        if (fieldDropdowns?.[fieldName]) {
            fieldDropdowns?.[fieldName].forEach(e => {
                isMobileRecommendation
                    ? dispatch(
                          mobileRecomActions.getMobileRecommendationDropdowns(
                              e,
                              e === "building_id"
                                  ? { site_id: value, project_id: projectId }
                                  : e === "system_id"
                                    ? {
                                          trade_id:
                                              fieldName === "sub_system_id"
                                                  ? getValidId(selectedSubSystem?.trade_id, trade_id ?? "")
                                                  : fieldName === "system_id"
                                                    ? getValidId(selectedSystem?.trade_id, trade_id)
                                                    : value,
                                          project_id: projectId
                                      }
                                    : e === "sub_system_id"
                                      ? {
                                            [fieldName === "system_id" && value
                                                ? "system_id"
                                                : fieldName === "sub_system_id"
                                                  ? getValidId(selectedSubSystem?.system_id, system_id)
                                                      ? "system_id"
                                                      : "trade_id"
                                                  : "trade_id"]:
                                                fieldName === "trade_id"
                                                    ? value
                                                    : fieldName === "sub_system_id"
                                                      ? getValidId(selectedSubSystem?.system_id, system_id, selectedSubSystem?.trade_id, trade_id)
                                                      : fieldName === "system_id"
                                                        ? value
                                                            ? value
                                                            : (trade_id ?? "")
                                                        : value,
                                            project_id: projectId
                                        }
                                      : e === "main_building_type_id"
                                        ? { client_id: clientId }
                                        : value,
                              e === "building_id" || e === "system_id" || e === "sub_system_id" || e === "main_building_type_id"
                          )
                      )
                    : dispatch(
                          assetActions.getDropdownList(
                              e,
                              { ...params, ...(isGeoHeirarchyFields.includes(e) && { field: e }) },
                              undefined,
                              isGeoHeirarchyFields.includes(e)
                          )
                      );
            });
        }
    };

    const handleInputChange = (newValue, { action }, manufacturerId) => {
        if (action === "input-change" || action === "input-click" || action === "input-blur") {
            const { client_id } = surveyProject || {};
            dispatch(
                assetActions.getDropdownList("manufacturers", {
                    search: newValue,
                    current_manufacturer: manufacturerId && manufacturerId,
                    client_id: client_id ?? queryParam?.c_id
                })
            );
            return newValue;
        }
    };

    const getInitialDropdowns = () => {
        if (surveyProject && !isMobileRecommendation) {
            const { client_id, region_id } = surveyProject;
            if (client_id) {
                dispatch(
                    assetActions.getDropdownList(
                        "regions",
                        {
                            client_id,
                            field: "regions"
                        },
                        undefined,
                        true
                    )
                );
                if (region_id)
                    dispatch(
                        assetActions.getDropdownList(
                            "sites",
                            {
                                region_id,
                                client_id,
                                field: "sites"
                            },
                            undefined,
                            true
                        )
                    );
                dispatch(
                    assetActions.getDropdownList("trades", {
                        client_id
                    })
                );
                dispatch(
                    assetActions.getDropdownList("asset_statuses", {
                        client_id
                    })
                );
                dispatch(
                    assetActions.getDropdownList("asset_types", {
                        client_id
                    })
                );
                dispatch(
                    assetActions.getDropdownList("asset_conditions", {
                        client_id
                    })
                );

                dispatch(assetActions.getDropdownList("building_types", { client_id }));

                dispatch(
                    assetActions.getDropdownList("main_categories", {
                        client_id
                    })
                );
                dispatch(
                    assetActions.getDropdownList(
                        "client_standards",
                        {
                            client_id
                        },
                        { asset_survey_project_id: getSurveyAssetById?.data?.asset?.asset_survey_project?.id, with_uniformat_parents: true }
                    )
                );

                dispatch(actions.getSuggestionDropdownByClient(client_id));
            }
            if (initialState) {
                const site_id = fieldUUIDExists("assets.site_id");
                const region_id = fieldUUIDExists("assets.region_id");
                const building_id = fieldUUIDExists("assets.building_id");
                const trade_id = fieldUUIDExists("assets.trade_id");
                const system_id = fieldUUIDExists("assets.system_id");
                const manufacturer_id = fieldUUIDExists("assets.manufacturer");
                const main_category_id = fieldUUIDExists("assets.main_category_id");
                const sub_category_1_id = fieldUUIDExists("assets.sub_category_1_id");
                const sub_category_2_id = fieldUUIDExists("assets.sub_category_2_id");
                if (region_id)
                    dispatch(
                        assetActions.getDropdownList(
                            "sites",
                            {
                                region_id: region_id,
                                client_id,
                                field: "sites"
                            },
                            undefined,
                            true
                        )
                    );
                if (manufacturer_id)
                    dispatch(
                        assetActions.getDropdownList("manufacturers", {
                            current_manufacturer: manufacturer_id,
                            client_id
                        })
                    );
                else
                    dispatch(
                        assetActions.getDropdownList("manufacturers", {
                            client_id
                        })
                    );

                if (site_id)
                    dispatch(
                        assetActions.getDropdownList(
                            "buildings",
                            {
                                site_id,
                                client_id,
                                field: "buildings"
                            },
                            undefined,
                            true
                        )
                    );
                if (building_id) {
                    dispatch(
                        assetActions.getDropdownList(
                            "floors",
                            {
                                building_id,
                                client_id,
                                field: "floors"
                            },
                            undefined,
                            true
                        )
                    );
                    dispatch(
                        assetActions.getDropdownList(
                            "additions",
                            {
                                building_id,
                                client_id,
                                field: "additions"
                            },
                            undefined,
                            true
                        )
                    );
                }
                if (trade_id)
                    dispatch(
                        assetActions.getDropdownList("systems", {
                            client_id: client_id,
                            trade_id
                        })
                    );
                if (system_id)
                    dispatch(
                        assetActions.getDropdownList("sub_systems", {
                            client_id: client_id,
                            system_id
                        })
                    );
                const fieldsToDispatch = [];

                Object.values(initialState ?? {}).forEach(fields => {
                    Object.keys(fields ?? {}).forEach(eachFieldKey => {
                        if (eachFieldKey?.startsWith("assets.uniformat_level_")) {
                            fieldsToDispatch.push(eachFieldKey);
                        }
                    });
                });
                const clientStandartFields = [];

                Object.values(initialState ?? {}).forEach(fields => {
                    Object.keys(fields ?? {}).forEach(eachFieldKey => {
                        if (eachFieldKey?.startsWith("assets.cs_l")) {
                            clientStandartFields.push(eachFieldKey);
                        }
                    });
                });

                if (fieldsToDispatch.length > 0) {
                    dispatch(
                        actions?.getAssetSurveyUniformatDropdown({
                            asset_survey_template_id: getSurveyAssetById?.data?.asset?.asset_survey_template_id,
                            fields: JSON.stringify(fieldsToDispatch)
                        })
                    );
                }
                if (clientStandartFields?.length > 0) {
                    dispatch(
                        assetSettingsActions?.getClientStandardStaticDropdown({
                            client_id: client_id,
                            asset_survey_project_id: getSurveyAssetById?.data?.asset?.asset_survey_project?.id,
                            fields: JSON.stringify([...clientStandartFields, "assets.survey_target_id"])
                        })
                    );
                }
                if (main_category_id)
                    dispatch(
                        assetActions.getDropdownList("sub_category_1s", {
                            client_id,
                            main_category_id
                        })
                    );

                if (sub_category_1_id)
                    dispatch(
                        assetActions.getDropdownList("sub_category_2s", {
                            client_id,
                            main_category_id,
                            sub_category_1_id
                        })
                    );

                if (sub_category_2_id)
                    dispatch(
                        assetActions.getDropdownList("sub_category_3s", {
                            client_id,
                            main_category_id,
                            sub_category_1_id,
                            sub_category_2_id
                        })
                    );
            }
        } else if (isMobileRecommendation && projectId && initialState) {
            const isAssetType = initialState?.Recommendations?.recommendation_type?.value?.toLowerCase() === "asset";
            const manufacturer_id = fieldUUIDExists(isAssetType ? "assets.manufacturer_id" : "manufacturer_id");
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("department_id", projectId));
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("trade_id", projectId));
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("category_id", projectId));
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("recommendation_capital_type_id", projectId));
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("funding_source_id", projectId));
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("responsibility_id", projectId));

            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("criticality_id", projectId));
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("initiative_id", { project_id: projectId }, true));
            dispatch(mobileRecomActions.getMobileRecommendationDropdowns("asset_condition_id", projectId));
            dispatch(projectActions.getUsersByProject(projectId, { is_surveyor_list: true }));
            dispatch(normalRecomStatusActions.statusDropdown(projectId));
            dispatch(normalRecomActions.getPriorityElementDropDownData(projectId));
            dispatch(normalRecomActions?.getRecommendationTemplates(undefined, `/projects/${projectId}/recommendation_templates`));

            const clientId = queryParam?.c_id;
            if (clientId) {
                dispatch(mobileRecomActions.getMobileRecommendationDropdowns("region_id", clientId));
                dispatch(mobileRecomActions.getMobileRecommendationDropdowns("main_building_type_id", { client_id: clientId }, true));
                if (manufacturer_id)
                    dispatch(
                        assetActions.getDropdownList("manufacturers", {
                            current_manufacturer: manufacturer_id,
                            client_id: clientId
                        })
                    );
                dispatch(assetActions.getDropdownList("asset_conditions", { client_id: clientId }));
            }
            const fields = Object.values(initialState).reduce((acc, item) => {
                acc = [...acc, ...Object.values(item)];
                return acc;
            }, []);

            const systemField = fields?.find(f => f?.field_name === "system_id");
            const tradeField = fields?.find(f => f?.field_name === "trade_id");
            const dropdownFields = {
                building_id: ["floor", "addition_id"],
                region_id: ["site_id"],
                site_id: ["building_id"],
                trade_id: ["system_id", ...(!systemField?.uuid && !systemField?.value ? ["sub_system_id"] : [])],
                system_id: [...(systemField?.uuid || systemField?.value ? ["sub_system_id"] : [])]
            };

            (fields ?? []).forEach(eachField => {
                if (
                    dropdownFields?.[eachField?.field_name] &&
                    (eachField?.uuid || (eachField?.value && ["system_id", "trade_id"].includes(eachField?.field_name)))
                ) {
                    dropdownFields?.[eachField?.field_name]?.forEach(e => {
                        let asParam = false;
                        if (["building_id", "system_id", "sub_system_id"].includes(e)) {
                            asParam = true;
                        }
                        dispatch(
                            mobileRecomActions.getMobileRecommendationDropdowns(
                                e,
                                e === "building_id"
                                    ? {
                                          site_id: eachField?.uuid,
                                          project_id: projectId
                                      }
                                    : e === "system_id"
                                      ? { trade_id: eachField?.uuid || eachField?.value, project_id: projectId }
                                      : e === "sub_system_id"
                                        ? {
                                              [eachField?.field_name === "trade_id" ? "trade_id" : "system_id"]: eachField?.uuid || eachField?.value,
                                              project_id: projectId
                                          }
                                        : eachField?.uuid,
                                asParam
                            )
                        );
                    });
                }
            });
            const trade_id = fieldUUIDExists("trade_id");
            const system_id = fieldUUIDExists("system_id");
            if (!trade_id && !tradeField?.value) dispatch(mobileRecomActions.getMobileRecommendationDropdowns("system_id", projectId));
            if (!system_id && !trade_id && !tradeField?.value && !systemField?.value)
                dispatch(mobileRecomActions.getMobileRecommendationDropdowns("sub_system_id", projectId));
        }
    };
    const getSuggestions = value => {
        const inputValue = value?.trim()?.toLowerCase() || "";

        return (getRecommendationTemplatesResponse?.project_sub_system_recommendation_templates || [])
            ?.filter(
                item =>
                    item.text_format?.toString()?.toLowerCase().includes(inputValue) ||
                    item.description?.toString()?.toLowerCase().includes(inputValue)
            )
            ?.slice(0, 40)
            ?.map(item => item?.description || item?.text_format);
    };
    const groupedOptions = (getStatusDropdwnResponse?.recommendation_status_data || [])
        .reduce((acc, item) => {
            if (item?.key === "deleted") return acc;
            const groupName = item?.group_name || "Others";

            let group = acc?.find(g => g?.label === groupName);
            if (!group) {
                group = { label: groupName, options: [] };
                acc.push(group);
            }
            group?.options?.push({
                label: item?.name,
                value: item?.id,
                description: item?.description,
                key: item?.key
            });

            return acc;
        }, [])
        ?.sort((a, b) => {
            return (a.label === "Others") - (b.label === "Others") || a.label.localeCompare(b.label);
        });

    return {
        data,
        handleSubmit,
        onCancel,
        handleChange,
        showErrorBorder,
        errorParams,
        showCancelConfirmModal,
        setShowCancelConfirmModal,
        cancelForm,
        toggleCreateDynamicForm,
        showCreateDynamicForm,
        initialData,
        handleInputChange,
        fieldSearch,
        setFieldSearch,
        fillEmptyFields,
        hasInvalidFields,
        invalidFields,
        setInvalidFields,
        staticData,
        getSuggestions,
        groupedOptions,
        onDirtyCheck,
        applyAutoPopulateGlobally,
        pendingServiceLifeChange,
        handleServiceLifeChangeApply,
        clearPendingServiceLifeChange
    };
};

export default useSurveyAssetFrom;
